import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["pageNavigationItemCount", "pageNavigationPageNumber", "onPageNavigationPageSelect", "enablePageNavigation", "pageNavigationPageSize", "enablePageNavigationPageSizeSelector", "onPageNavigationPageSizeChange", "pageNavigationPageSizeList"];
export var useDataTablePageNavigation = function useDataTablePageNavigation(_ref) {
  var pageNavigationItemCount = _ref.pageNavigationItemCount,
      pageNavigationPageNumber = _ref.pageNavigationPageNumber,
      onPageNavigationPageSelect = _ref.onPageNavigationPageSelect,
      enablePageNavigation = _ref.enablePageNavigation,
      pageNavigationPageSize = _ref.pageNavigationPageSize,
      enablePageNavigationPageSizeSelector = _ref.enablePageNavigationPageSizeSelector,
      onPageNavigationPageSizeChange = _ref.onPageNavigationPageSizeChange,
      pageNavigationPageSizeList = _ref.pageNavigationPageSizeList,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return {
    result: {
      pageNavigationProps: {
        itemCount: pageNavigationItemCount,
        pageNumber: pageNavigationPageNumber,
        onPageSelect: onPageNavigationPageSelect,
        pageSize: pageNavigationPageSize,
        enablePageSizeSelector: enablePageNavigationPageSizeSelector,
        onPageSizeChange: onPageNavigationPageSizeChange,
        pageSizeList: pageNavigationPageSizeList
      },
      enablePageNavigation: enablePageNavigation
    },
    restProps: restProps
  };
};